import ProgressBar from './ProgressBar.view';

export default ProgressBar;
